// src/pages/Home.tsx
import Hero from '../components/Hero';
import CoursesSection from './Courses';
import AboutSection from './About';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <>
      <Hero />
      <CoursesSection />
      <AboutSection />
      <Testimonials />
      <CTA />
    </>
  );
};

export default Home;